import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Fade,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SubCategoryModal from "./SubCategoryModal";
import { ModalStyle } from "../Theme";
import { useSnackbar } from "notistack";
import { sCategory, sHeading } from "../Strings";

function EditModal({ value, i }) {
  // const { values } = props;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [values, setValues] = React.useState([]);
  const { enqueueSnackbar } = useSnackbar();

  var itemRef = doc(db, sCategory, value.id);

  if (i === 0) itemRef = doc(db, sHeading, value.id);

  useEffect(() => {
    setValues(value);
  }, []);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  function setUpdate() {
    setDoc(itemRef, { name: values.name }, { merge: true }).then((snapshot) => {
      enqueueSnackbar("Category Updated!", { variant: "success" });
      console.log(value.id);
    });
  }

  return (
    <div>
      <IconButton size="small" sx={{ mr: 2 }} onClick={handleOpen}>
        <EditIcon fontSize="small" />
      </IconButton>

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={ModalStyle}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 3 }}
            >
              Edit Category
            </Typography>

            {/* <Box sx={{ width: "100%", mb: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Top Category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={sCategory}
                  label="Top Category"
                  onChange={handleChangeSelect}
                >
                  {category.map((value, key) => (
                    <MenuItem key={key} value={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box> */}

            <div>
              <TextField
                className="inputRounded"
                sx={{ mb: 4, width: "100%" }}
                label="Category Name"
                type="text"
                value={values.name}
                variant="outlined"
                onChange={handleChange("name")}
              />
            </div>

            <Button
              onClick={setUpdate}
              variant="contained"
              disableElevation
              sx={{ width: "100%", height: 50, borderRadius: 2 }}
            >
              Submit
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

function CollapseList({ id }) {
  const [category, setCategory] = useState([]);
  const [open, setOpen] = React.useState(true);
  const { enqueueSnackbar } = useSnackbar();

  // query sub cats for parent id
  const categoryRef = query(
    collection(db, sCategory),
    where("parent", "==", id)
  );

  useEffect(() => {
    // get other categories based on parent id
    onSnapshot(categoryRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCategory(data);
      setOpen(false); // loading icon
    });
  }, []);

  function Row(props) {
    const { value } = props;
    // create document ref
    const itemRef = doc(db, sCategory, value.id);

    const deleteSubCat = () => {
      // console.log("Deleted ", id);
      // return;

      deleteDoc(itemRef).then(() => {
        enqueueSnackbar("Category Updated!", { variant: "success" });
        console.log("Deleted");
      });
    };

    return (
      <ListItem sx={{ pl: 8, pr: 1 }} disablePadding>
        <ListItemButton>
          <ListItemText
            primary={value.name}
            primaryTypographyProps={{ fontSize: "14px" }}
          />

          {/* <IconButton
          size="small"
          sx={{ mr: 2 }}
          onClick={() => editSubCat(value.id)}
        >
          <EditIcon fontSize="small" />
        </IconButton> */}

          <EditModal value={value} />

          <DeleteIcon fontSize="small" onClick={deleteSubCat} />
        </ListItemButton>
      </ListItem>
    );
  }

  return (
    <div>
      <div>
        {/* <Button
          variant="contained"
          disableElevation
          sx={{ width: 150, height: 30, borderRadius: 1, fontSize: 10, ml: 7 }}
        >
          Add Category
        </Button> */}
      </div>

      {open ? (
        <ListItem sx={{ pl: 10 }}>
          <CircularProgress size={20} />
        </ListItem>
      ) : null}

      {category.map((value, key) => (
        <Row value={value} key={key} />
      ))}

      {category === 0 ? (
        <ListItem sx={{ pl: 8 }} disablePadding>
          <ListItemText
            primary="Empty"
            primaryTypographyProps={{ fontSize: "14px" }}
          />
        </ListItem>
      ) : null}
    </div>
  );
}
export { CollapseList, EditModal };
